<template>
    <div class="d-flex flex-1 h-100 overflow-auto">
        <v-card class="report-container w-100 p-0" style="border-radius: 12px; margin-bottom: 24px">
            <v-toolbar class="shadow-none" style="flex: unset" content-class="h-auto">
                <div class="custom-icon-wrapper">
                    <v-icon @click="backToAdminPage()">custom-icon left-arrow-icon</v-icon>
                </div>
                <v-toolbar-title class="size-16 dark-text">{{ $t("res_Title_Committees") }}</v-toolbar-title>
            </v-toolbar>

            <div class="border-top p-4 flex-1 overflow-auto">
                <div class="row align-items-start flex-nowrap m-0 gap-2" style="flex: unset">
                    <div class="col-md-4 p-0">
                        <v-label>{{ searchTermlbl }}</v-label>
                        <v-text-field v-model="searchTerm" label="" solo></v-text-field>
                    </div>
                    <div class="col-md-4 p-0 h-100">
                        <div class="d-flex gap-2 h-100 align-items-end">
                            <v-btn color="light-blue" dense @click="clearFilter()">{{ $t("res_ButtonText_Clear") }}</v-btn>
                            <v-btn color="primary" dense @click="getCouncil()">{{ $t("res_ButtonText_Search") }}</v-btn>
                            <v-btn color="primary" @click="dialog = true">{{ $t("res_ButtonText_Add") }}</v-btn>
                        </div>
                    </div>
                </div>

                <Pagination class="mb-2" :totalCount="pagingData.totalCount" :pageSize="pagingData.pageSize" :pageIndex="pagingData.pageIndex" @pageIndexChanged="pageIndexChanged"></Pagination>

				<div class="d-flex flex-1 flex-column overflow-auto mt-2"> 
                    <v-data-table
                        :mobile-breakpoint="0"
                        class="position-relative white flex-1 d-flex overflow-auto elevation-1 CommitteesTable"
                        disable-sort
                        loading-text="loading..."
                        :no-data-text="$t('res_Label_NoData')"
                        :footer-props="{'items-per-page-text': 'Items per page'}"
                        caption=""
                        hide-default-footer
                        header-fixed
                        :class="{'no-data': CouncilData.length == 0}"
                        :items-per-page="pagingData.pageSize"
                        :headers="headers"
                        :items="CouncilData"
                        item-key="id">
                        <template v-slot:headers="{headers}">
                            <tr>
                                <th style="background-color: #e7ebef" v-for="header in headers" :key="header.text">
                                    {{ header.text }}
                                </th>
                            </tr>
                        </template>

                        <template v-slot:item="row">
                            <tr>
                                <td class="w-25 text-center">{{ row.item.baseDetails.CouncilName }}</td>
                                <td class="w-25 text-center">{{ row.item.baseDetails.CouncilNameAr }}</td>
                                <td class="w-25 text-center">{{ row.item.baseDetails.Active ? $t("res_ButtonText_Yes"): $t("res_ButtonText_No") }}</td>
                                <td class="text-end">
                                    <div style="display: flex; align-items: center; justify-content: flex-end" class="CommitteesActionstd">
                                        <div class="custom-icon-wrapper">
                                            <a @click="showUsersDilog(row.item)" v-tooltip.hover="$t('res_Title_ManageUsers')" class="custom-table-icon">
                                                <span class="mdi mdi-account-outline" style="font-size: 20px"></span>
                                            </a>
                                        </div>
                                        <div class="custom-icon-wrapper">
                                            <v-icon v-tooltip.hover="$t('Update')" @click="showEditDialog(row.item)">custom-icon white-bg edit-icon</v-icon>
                                        </div>
                                        <div class="custom-icon-wrapper">
                                            <v-icon v-tooltip.hover="$t('res_ButtonText_Delete')" @click="deleteCouncil(row.item)">custom-icon white-bg delete-icon</v-icon>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </div>
            </div>
        </v-card>

        <v-dialog v-model="addStructureUser" max-width="800px">
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">{{ $t("res_label_manager_committee_Member") }}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="addStructureUser = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
                <v-card-text>
                    <div class="row mb-3 mt-2">
                        <div class="col-10">
                            <StructureUserSelector
                                :showInternalUsers="true"
							    :showExternalUsers="false"
                                :showInternalStructures="false"
							    :showExternalStructures="false"
                                :excludeSelf="false"
								:isMultiple="false" 
								:selectedStructureUser="selectedUsers"
                                @structureUserSelectChanged="updateselectedUsers"
								addressBook_header="Select User" >
                            </StructureUserSelector>
                        </div>
                        <div class="col-2 m-auto">
                            <v-btn :disabled="selectedUsers == null || (selectedUsers.id == null || selectedUsers.id == '')" style="width: 100px" color="primary" variant="text" @click="saveChanges(Title,TitleAr,IsHead,CanSign,ContactOrder)">
                                {{ $t("res_ButtonText_Add") }}
                            </v-btn>
                        </div>
                    </div>
					<div class="row mb-3 mt-2">
						<v-col cols="6">
                                <label style="padding-bottom: 10px">{{ $t("res_Label_Title") }}</label>
                                <v-text-field maxlength="150" v-model="Title" label="" solo></v-text-field>
                         </v-col>
                            <v-col cols="6">
                                <label style="padding-bottom: 10px">{{ $t("res_Label_TitleAr") }}</label>
                                <v-text-field maxlength="150" v-model="TitleAr" label="" solo></v-text-field>
                            </v-col>
							<v-col cols="3">
                                <div class="with-absolute-button">
                                     <v-label class="mt-3 mb-0">{{ $t('res_CheckBox_IsHead') }}</v-label>
                                     <v-checkbox class="mb-0 mt-0" v-model="IsHead" solo></v-checkbox>
                                </div>
                            </v-col>
							<v-col cols="3">
                                <div class="with-absolute-button">
                                     <v-label class="mt-3 mb-0">{{ $t('res_Label_CanSign') }}</v-label>
                                     <v-checkbox class="mb-0 mt-0" v-model="CanSign" solo></v-checkbox>
                                </div>
                            </v-col>
							<v-col cols="6">
                                <label style="padding-bottom: 10px">{{ $t("res_Label_Order") }}</label>
                                <v-text-field maxlength="150" v-model="ContactOrder" label="" solo></v-text-field>
                            </v-col>
					</div>
                    <div class="row">
                        <div class="col-12">
                            <v-data-table
                                :headers="Users_Headers"
                                :items="council_users_items"
                                item-key="id"
                                class="elevation-1"
                                id="usersTable"
                                :mobile-breakpoint="0"
                                disable-sort
                                loading-text="loading..."
                                :no-data-text="$t('res_Label_NoData')"
                                :footer-props="{'items-per-page-text': 'Items per page'}"
                                caption=""
                                hide-default-footer
                                header-fixed>
                                <template v-slot:item="row">
                                    <tr>
                                        <td class="text-center"> 
											  {{ row.item.usersDetails.Title }}
                                        </td> 
										<td class="text-center"> 
											  {{ row.item.usersDetails.TitleAr }}
                                        </td> 
										<td class="text-center" >{{ row.item.usersDetails.IsHead ? $t("res_ButtonText_Yes") : $t("res_ButtonText_No") }}</td> 
                                        <td class="text-center" >{{ row.item.usersDetails.CanSign ? $t("res_ButtonText_Yes") : $t("res_ButtonText_No") }}</td> 
										<td class="text-center" >{{ row.item.usersDetails.ContactOrder }}</td> 

										<td class="text-end">
                                            <div style="display: flex; align-items: center; justify-content: flex-end" class="CommitteesActionstd"> 

												<div class="custom-icon-wrapper">
													<v-icon v-tooltip.hover="$t('Update')" @click="EditCouncilMember(row.item)">custom-icon white-bg edit-icon</v-icon>
												</div>

                                                <div class="custom-icon-wrapper structuresTableDeleteAction">
                                                    <v-icon v-tooltip.hover="$t('res_ButtonText_Delete')" @click="DeleteCouncilMember(row.item.usersDetails.ID)">custom-icon white-bg delete-icon</v-icon>
                                                </div> 
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions class="gap-2 sticky-actions" style="">
                    <v-spacer></v-spacer>
                    <v-btn class="light-blue" @click="addStructureUser = false">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="editName" max-width="600px">
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">{{ $t("res_ButtonText_Edit") }}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="editName = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="6">
                                <label style="padding-bottom: 10px">{{ $t("res_Label_NameEn") }}</label>
                                <v-text-field maxlength="150" v-model="selectedCouncilName" label="" solo></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <label style="padding-bottom: 10px">{{ $t("res_Label__NameAr") }}</label>
                                <v-text-field maxlength="150" v-model="selectedCouncilNameAr" label="" solo></v-text-field>
                            </v-col>
							<v-col cols="12">
                                <div class="with-absolute-button">
                                     <v-label class="mt-3 mb-0">{{ $t('res_CheckBox_Active') }}</v-label>
                                     <v-checkbox class="mb-0 mt-0" v-model="active" solo></v-checkbox>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions class="gap-2 sticky-actions">
                    <v-spacer></v-spacer>
                    <v-btn class="light-blue" @click="editName = false">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                    <v-btn color="primary" variant="text" @click="saveEditChanges">
                        {{ $t("res_ButtonText_Continue") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" persistent max-width="600px">
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">{{ $t("res_ButtonText_New") }}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>

                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="6" md="6">
                                <label style="padding-bottom: 10px">{{ $t("res_Label_NameEn") }}</label>
                                <v-text-field maxlength="150" v-model="CouncilName" label="" solo></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <label style="padding-bottom: 10px">{{ $t("res_Label__NameAr") }}</label>
                                <v-text-field maxlength="150" v-model="CouncilNameAr" label="" solo></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <div class="with-absolute-button">
                                     <v-label class="mt-3 mb-0">{{ $t('res_CheckBox_Active') }}</v-label>
                                     <v-checkbox class="mb-0 mt-0" v-model="active" solo></v-checkbox>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions class="gap-2 sticky-actions">
                    <v-spacer></v-spacer>
                    <v-btn class="light-blue" @click="dialog = false">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                    <v-btn color="primary" variant="text" @click="saveCouncil(CouncilName, CouncilNameAr, active)">
                        {{ $t("res_ButtonText_Continue") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import * as utils from "@/assets/js/common.js";
import StructureUserSelector from "@/components/StructureUserSelector.vue"; 
import constants from "@/assets/js/constants.js";
import axios from "axios";
import router from "@/router/index.js";
import Pagination from "@/components/Pagination.vue";
import { ID } from "@/assets/js/orgchart";

export default {
	name: "ManageCouncilAndMembers",
	components: { StructureUserSelector, Pagination },
	data: function () {
		return {
			pagingData: {
				pageSize: 10,
				pageIndex: 0,
				totalCount: 0,
			},
			totalRows: 0,
			council_users_items: [],
			searchTerm: "",
			searchTermlbl: this.$t("res_Label_SearchforCommittees"),
			searchName: "",
			CouncilData: [],
			selectedCouncilNameAr: "",
			selectedCouncilName: "",
			editName: false,
			editedItem: {},
			selectedStructureId: null,
			selectedCouncilId: null,
			selectedUserId: -1,
			councilMembers: [],
			selectedEntity: [],
			addStructureUser: false,
			structureDialog: false,
			selectedUsers: { id: "", name: ""},
			councilMembers: null,
			alert: false, 
			alertMessage: "",
			alertColor: "",
			radioitems: {
				type: 0,
			},
			selectedRadios: "External",
			dialog: false,
			filterByName: "",
			selected: [],
			headers: [
				{ text: this.$t("res_GridHeaders_EnValue"), value: "CouncilName" },
				{ text: this.$t("res_GridHeaders_ArValue"), value: "CouncilNameAr" },
				{ text: this.$t("res_GridHeaders_Active"), value: "Active" },
				{ value: "actions", sortable: false },
			],
			Users_Headers: [
				{
					text: this.$t("res_Label_Title"),
					class: "text-center",
					sortable: false,
				},
				{
					text: this.$t("res_Label_TitleAr"),
					class: "text-center",
					sortable: false,
				},
				{
					text: this.$t("res_CheckBox_IsHead"),
					class: "text-center",
					sortable: false,
				},
				{
					text: this.$t("res_GridHeaders_CanSign"),
					class: "text-center",
					sortable: false,
				},
				{
					text: this.$t("res_Label_Order"),
					class: "text-center",
					sortable: false,
				}
			],
			names: [{ name: "", nameAr: "", type: 0 }],
			CouncilData: [], // Renaming the data property
			name: "",
			nameAr: "",
			type: 0,
			id: 0,
			councilMembers: null,
			active:false,
			Title:"",
			TitleAr:"",
			IsHead:false,
			CanSign:false,
			CouncilNameAr:"",
			CouncilName:"",
			CouncilMemberId:0,
			ContactOrder:1
		};
	},
	methods: {
		backToAdminPage() {
			router.push({ name: "admin" });
		},
		clearFilter() {
			this.searchTerm = "";
			this.getCouncil();
		},
		getCouncil() {
			 	var isPowerUser=constants.isCompanyAdmin && !constants.isFullAdmin;
			axios
				.get(
					constants.baseApiUrl +
						`Council/GetAllCouncils?searchTerm=${this.searchTerm.trim()}&PageNumber=${
							this.pagingData.pageIndex
						}&PageSize=${this.pagingData.pageSize}&isPowerUser=${isPowerUser}`
				)
				.then((res) => {
					if (
						res != null &&
						res != undefined &&
						res.data != "" &&
						res.data != null
					) {
						this.totalRows = res.data.total;
						this.pagingData.totalCount = res.data.total;
					} else {
						this.totalRows = 0;
						this.pagingData.totalCount = 0;
					}
				
					this.CouncilData = res.data.records;
				})
				.catch((err) => console.warn(err));
		},
		usersForCouncil(entityGroupId) {
			const entityGroup = this.CouncilData.find(
				(e) => e.baseDetails.id === entityGroupId
			);
			if (entityGroup) {
				return entityGroup.councilMembers.map(
					(structureUserGroup) => {
						return {
							...structureUserGroup,
							name: structureUserGroup.name,
						};
					}
				);
			} else return [];
		},
		getCouncil: function () {
			
			var isPowerUser=constants.isCompanyAdmin && !constants.isFullAdmin;
			axios
				.get(
					constants.baseApiUrl +
						`Council/GetAllCouncils?searchTerm=${this.searchTerm.trim()}&PageNumber=${
							this.pagingData.pageIndex
						}&PageSize=${this.pagingData.pageSize}&isPowerUser=${isPowerUser}`
				)
				.then((res) => {
					if (
						res != null &&
						res != undefined &&
						res.data != "" &&
						res.data != null
					) {
						this.totalRows = res.data.total;
						this.pagingData.totalCount = res.data.total;
					} else {
						this.totalRows = 0;
						this.pagingData.totalCount = 0;
					}
					 
					this.CouncilData = res.data.records.map((entity) => {
						return {
							baseDetails: {
								ID: entity.id,
								CouncilName: entity.councilName,
								CouncilNameAr: entity.councilNameAr,
								Active: entity.active,
							},
							councilMembers:
								entity.councilMembers == null
									? []
									: entity.councilMembers.map(
											(CouncilMember) => {
												return {
													usersDetails: {
														ID: CouncilMember.id,
														CouncilID: CouncilMember.councilID,
														UserId: CouncilMember.userId,
														Title: CouncilMember.title,
														TitleAr: CouncilMember.titleAr,
														IsHead:CouncilMember.isHead,
														CanSign:CouncilMember.canSign,
														StructureId:CouncilMember.structureId,
														ContactOrder:CouncilMember.contactOrder
													},
												};
											}
									  ) || [],
						};
					});
				})
				.catch((err) => console.warn(err));
		},
		usersForCouncil(entityGroupId) { 
			const entityGroup = this.CouncilData.find(
				(e) => e.baseDetails.ID === entityGroupId
			);
			return entityGroup ? entityGroup.councilMembers : [];
		},
		showUsersDilog(item) { 
			this.selectedCouncilId = item.baseDetails.ID;
			this.council_users_items = this.usersForCouncil(
				this.selectedCouncilId
			);
			this.addStructureUser = true;
			this.Title="";
			this.TitleAr="";
			this.IsHead=false;
			this.CanSign=false;
			this.ContactOrder=1;
		},
		saveEditChanges() {
			let updatedItem = {
				ID: this.selectedCouncilId,
				CouncilName: this.selectedCouncilName,
				CouncilNameAr: this.selectedCouncilNameAr,
				Active:this.active
			};

			this.updateCouncilName(updatedItem);
			this.editName = false;
		},
		showEditDialog(item) {
			this.editName = true;
			this.selectedCouncilId = item.baseDetails.ID;
			this.council_users_items = this.usersForCouncil(
				this.selectedCouncilId
			);
			this.selectedCouncilName = item.baseDetails.CouncilName;
			this.selectedCouncilNameAr = item.baseDetails.CouncilNameAr;
			this.active = item.baseDetails.Active;
		},
		saveChanges(Title,TitleAr,IsHead,CanSign,ContactOrder) {
		
			this.addEditUserToCouncil(
				this.selectedCouncilId,
				typeof this.selectedUsers.id != "undefined" && this.selectedUsers.id.includes("-") ? this.selectedUsers.id : null,
				Title,TitleAr,IsHead,CanSign,ContactOrder
			);
			this.selectedUsers = { id: "", name: ""}
			this.Title="";
			this.TitleAr="";
			this.IsHead=false;
			this.CanSign=false;
			this.ContactOrder=1;
		},
		async updateCouncilName(item) {
			axios
				.put(
					`${constants.baseApiUrl}Council/EditCouncilName`,
					{ ID: item.ID, CouncilName: item.CouncilName, CouncilNameAr: item.CouncilNameAr,Active:item.Active },
					{
						params: {
							entityId: item.ID,
						},
					}
				)
				.then((res) => {
					window.showAlert("res_Msgs_UpdateCommitteeSuccess","success");
					this.getCouncil();
				})
				.catch((err) => console.warn(err));
		},
		async EditCouncilMember(item) {
			this.Title=item.usersDetails.Title;
			this.TitleAr=item.usersDetails.TitleAr;
			this.IsHead=item.usersDetails.IsHead;
			this.CanSign=item.usersDetails.CanSign;
			this.CouncilMemberId=item.usersDetails.ID;
			this.ContactOrder=item.usersDetails.ContactOrder;
			axios.get(constants.baseApiUrl + 'User/GetUserInfo?userId=' + item.usersDetails.UserId+'&structureId='+item.usersDetails.StructureId)
                .then(response => {
			         this.selectedUsers = {id:""+item.usersDetails.UserId +"-"+item.usersDetails.StructureId+"",name:""+response.data.fullName+""}

                })
                .catch(error => console.log(error))
		},
		deleteCouncil(item) {
			
			this.selectedCouncilId = item.baseDetails.ID;
			if(item.councilMembers.length==0){
				axios
				.delete(
					`${constants.baseApiUrl}Council/DeleteCouncil?id=` +
						this.selectedCouncilId
				)
				.then((res) => {
					window.showAlert("res_Msgs_CommitteeDeleted","success");
					this.getCouncil();
				})
				.catch((err) => console.warn(err));
			}else{
				window.showAlert('res_Msgs_DeleteAllmember', 'warning');
			}
			
		},
		updateselectedUsers(newStructures) { 
			this.selectedUsers = newStructures;
		},
		DeleteCouncilMember(id) { 
			axios
				.delete(
					constants.baseApiUrl +
						`Council/DeleteCouncilMember?id=${id}`
				)
				.then((res) => {
					this.$nextTick(() => {
						this.council_users_items = [...this.council_users_items.filter(
							(s) => s.usersDetails.ID !== id
							)];
							window.showAlert("res_Msgs_CommitteeMemberDeleted","success");
					});
				})
				.catch((err) => console.warn(err));
		},
		addEditUserToCouncil(councilId, userId, Title,TitleAr,IsHead,CanSign,ContactOrder) 
		{ 
			let structureIdForUserId = userId == null || !userId.includes('-') ? null : userId.split('-')[1];
			userId = userId == null || !userId.includes('-') ? null : userId.split('-')[0];

		    var newUser = this.council_users_items.filter(
						(s) => s.usersDetails.UserId==userId && s.usersDetails.StructureId == structureIdForUserId
					);

			axios.post(`${constants.baseApiUrl}Council/AddEditCouncilMember`,
					{
						Id:newUser.length==1 ?this.CouncilMemberId :0 ,
						CouncilID: councilId,
						userId: userId,
						Title:Title ,
						TitleAr:TitleAr ,
						IsHead:IsHead,
						CanSign:CanSign,
						StructureId:structureIdForUserId,
						ContactOrder:ContactOrder
					}
				)
				.then((response) => { 
					
					if (response && response.data && response.data.length>0) {
						this.$nextTick(() => {
							this.council_users_items=[];
							response.data.forEach((councilData) => {
								this.council_users_items.push({
									usersDetails: {
										ID:councilData.id,
										UserId: councilData.userId,
										CouncilID:  councilData.councilID,
										Title:  councilData.title,
										TitleAr: councilData.titleAr,
										IsHead: councilData.isHead,
										CanSign:councilData.canSign,
										StructureId:councilData.structureId,
										ContactOrder:councilData.contactOrder
									},
							     });
							})

							if(newUser.length==1 ){
						         window.showAlert("res_Msgs_AddCommitteeMemberSuccess","success");
							}
							else{

								window.showAlert("res_Msgs_UpdateCommitteeMemberSuccess","success");
							}
						
						});

					} 
				})
				.catch((error) => {
					console.error("Error:", error);
				});
			
		},
		async addCouncil(CouncilName, CouncilNameAr, active) {
			try {
				const response = await axios.post(
				`${constants.baseApiUrl}Council/SaveCouncil`,
					{
						CouncilName: CouncilName,
						CouncilNameAr: CouncilNameAr,
						active: active,
					}
				);
				window.showAlert("res_Msgs_AddCommitteeSuccess","success");

				console.log("Success:", response);
				return response;
			} catch (error) {
				console.error("Error:", error);
				throw error;
			}
		},
		async saveCouncil(CouncilName, CouncilNameAr, active) { 
			try {
				await this.addCouncil(CouncilName, CouncilNameAr, active);

				this.dialog = false;
				this.alertMessage = "Saved";
				this.alertColor = "green";
				this.alert = true;

				await this.getCouncil();
			} catch (error) {
				this.alertMessage = "An error occurred. Please try again.";
				this.alertColor = "red";
				this.alert = true;
			}
		},
		pageIndexChanged(pagingData) {
			this.pagingData.pageSize = pagingData.pageSize;
			this.pagingData.pageIndex = pagingData.pageIndex;
			this.getCouncil();
		},
	},
	computed: {
		filteredNames() {
			return this.names.filter((eachname) => {
				return eachname.name
					.toLowerCase()
					.includes(this.filterByName.toLowerCase());
			});
		}
		
	},
	mounted() {
		
		 this.getCouncil();
		 this.Users_Headers.push({ text: "", value: "actions", sortable: false });
	},
};
</script>

<style>
.CommitteesActionstd .custom-icon-wrapper {
    margin: 0px 4px;
}
.CommitteesTable thead th span {
    justify-content: center !important;
}

.custom-table-icon {
    padding: 14px 9px 8px 9px;
    border-radius: 6px;
}

.custom-table-icon span {
    color: #959fb4 !important;
}

.custom-table-icon:hover {
    background-color: #e4ebfb;
}

.custom-table-icon:hover span {
    color: #4577e5 !important;
}

#usersTable thead th span {
    justify-content: center !important;
}
#usersTable {
    max-height: 350px;
    overflow-y: auto;
    overflow-x: hidden;
}
</style>
<style scoped>
.v-data-table-header th {
    background-color: #e7ebef;
}
.multiselect__tag-icon {
    display: none !important;
}
.v-icon.notranslate.v-data-table-header__icon {
    display: none !important;
}

.vtooltip {
    background-color: white;
    padding: 5px;
    border-radius: 25px;
}
.report-container .v-input--selection-controls {
    margin-top: 0;
    padding-top: 0;
}

.report_header {
    height: 50px;
    vertical-align: middle;
    font-weight: 500;
    font-size: 12px;
    letter-spacing: 0.015em;
    color: #667593;
}

.report-container .theme--light.v-data-table.v-data-table--fixed-header thead th,
.report-container .v-data-table__wrapper table thead {
    background-color: #fff;
    box-shadow: none;
}

.report-container {
    height: calc(100vh - 116px);
    display: flex;
    flex-direction: column;
    border-radius: 12px !important;
    overflow: auto;
    box-shadow: none !important;
}

.report-container .border-top {
    display: flex;
    flex-direction: column;
}

.report-container .v-toolbar {
    height: 80px !important;
    padding: 0;
}
.report-container .v-toolbar__content {
    height: 100% !important;
    padding: 24px !important;
}
img#ItemPreview {
    width: 100px;
    margin: 0.5rem 0;
}
.mdi-menu-down {
    filter: brightness(0) saturate(100%) invert(39%) sepia(56%) saturate(232%) hue-rotate(182deg) brightness(102%) contrast(83%) !important ;
}
.v-dialog .v-toolbar__content {
    height: 100% !important;
}
</style>
